import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { LegalTechnologyProtectedUnauthorizedModel } from './types';
import { legalTechnologyProtectedUnauthorizedItemValidator } from './validators/item';

const legalTechnologyProtectedUnauthorizedValidator: ValidateJSModel<LegalTechnologyProtectedUnauthorizedModel> = {
  HasProtectedUnauthorized: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes) => {
    if (attributes?.HasProtectedUnauthorized && attributes?.HasProtectedUnauthorized.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalTechnologyProtectedUnauthorizedItemValidator },
      };
    }
    return {};
  },
};
export default legalTechnologyProtectedUnauthorizedValidator;
